"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErrorMetadataView = void 0;
const react_1 = __importStar(require("react"));
function createErrorMetadataView(...plugins) {
    return props => {
        const { error: errorProp, children } = props;
        const [error, setError] = (0, react_1.useState)(errorProp);
        const { metadata } = error || {};
        const plugin = metadata && plugins.find(plugin => plugin.type === metadata.type);
        (0, react_1.useEffect)(() => {
            errorProp && setError(errorProp);
        }, [errorProp]);
        if (!plugin || !(error === null || error === void 0 ? void 0 : error.metadata)) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        const pluginProps = {
            children,
            error: error,
            onCancel: () => setError(undefined)
        };
        return react_1.default.createElement(plugin.render, Object.assign({}, pluginProps));
    };
}
exports.createErrorMetadataView = createErrorMetadataView;
//# sourceMappingURL=ErrorMetadataView.js.map